import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { Copyright } from '../../Copyright';
import { ContactsBancoValor } from './Contacts';
import { FooterStyled } from './FooterBancoValor.styles';

export const FooterBancoValor = ({ id, className }) => (
  <Box>
    <FooterStyled id={id ?? 'footer'} className={className ?? null}>
      <ContactsBancoValor />
    </FooterStyled>

    <Copyright />
  </Box>
);

FooterBancoValor.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
};
